export default __webpack_public_path__ + "static/media/tile_WXTornado.f8eb8de1.svg";